<template>
    <div>
        <v-card flat>
            <!-- <v-card-title>Thème</v-card-title> -->
            <!-- 64px height-->
            <v-row
                no-gutters
                class="px-2 py-3 align-start scrollbar-hidden"
                style="height: calc(100vh - 52px - 176px); overflow-y: auto"
            >
                <v-col cols="12">
                    <v-expansion-panels variant="accordion" flat>
                        <v-expansion-panel>
                            <v-expansion-panel-title class="px-2">
                                <div>
                                    <v-icon class="mr-2" size="small">$fa-file-alt</v-icon>
                                    {{ generalThemeSettingsOptions.label }}
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="wrapper-px-2">
                                <PropertiesEditor
                                    v-if="generalThemeSettingsOptions.properties"
                                    :perRow="2"
                                    :properties="generalThemeSettings.themesList[0].values"
                                    :propertiesOptions="generalThemeSettingsOptions.properties"
                                />
                                <v-divider class="my-3" />

                                <!-- <span>{{ generalThemeSettingsOptions.title.label }}</span>
                                <PropertiesEditor v-if="generalThemeSettingsOptions.title.properties" :perRow="2" :properties="generalThemeSettings.themesList[0].values.title" :propertiesOptions="generalThemeSettingsOptions.title.properties"></PropertiesEditor>
                                <v-divider class="my-3"></v-divider> -->

                                <span>{{ generalThemeSettingsOptions.boxStyle.label }}</span>
                                <PropertiesEditor
                                    v-if="generalThemeSettingsOptions.boxStyle.properties"
                                    :properties="generalThemeSettings.themesList[0].values.boxStyle"
                                    :propertiesOptions="
                                        generalThemeSettingsOptions.boxStyle.properties
                                    "
                                />
                                <v-divider class="my-3" />

                                <span>{{ generalThemeSettingsOptions.boxTitleStyle.label }}</span>
                                <PropertiesEditor
                                    v-if="generalThemeSettingsOptions.boxTitleStyle.properties"
                                    :properties="
                                        generalThemeSettings.themesList[0].values.boxTitleStyle
                                    "
                                    :propertiesOptions="
                                        generalThemeSettingsOptions.boxTitleStyle.properties
                                    "
                                />
                                <v-divider class="my-3" />

                                <v-expansion-panels
                                    v-if="titleLevels && titleLevels.length"
                                    variant="accordion"
                                    flat
                                >
                                    <template v-for="(titleLevel, index) of titleLevels">
                                        <v-expansion-panel
                                            v-if="
                                                generalThemeSettings.themesList[0].values[
                                                    titleLevel
                                                ]
                                            "
                                            :key="index"
                                        >
                                            <v-expansion-panel-title class="px-2">
                                                <template #actions>
                                                    <v-icon size="x-small">$fa-plus</v-icon>
                                                </template>
                                                <span
                                                    :style="
                                                        textStyle(
                                                            generalThemeSettings.themesList[0]
                                                                .values[titleLevel]
                                                        )
                                                    "
                                                    >{{
                                                        generalThemeSettingsOptions[titleLevel]
                                                            .label
                                                    }}</span
                                                >
                                            </v-expansion-panel-title>
                                            <v-expansion-panel-text class="wrapper-px-2">
                                                <PropertiesEditor
                                                    v-if="
                                                        generalThemeSettingsOptions[titleLevel]
                                                            .properties
                                                    "
                                                    :properties="
                                                        generalThemeSettings.themesList[0].values[
                                                            titleLevel
                                                        ]
                                                    "
                                                    :propertiesOptions="
                                                        generalThemeSettingsOptions[titleLevel]
                                                            .properties
                                                    "
                                                />
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>
                                    </template>
                                </v-expansion-panels>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-title class="px-2">
                                <div>
                                    <v-icon class="mr-2 2" size="small">$fa-chart-bar</v-icon>
                                    {{ chartsThemeSettingsOptions.label }}
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="wrapper-px-2">
                                <v-expansion-panels
                                    flat
                                    variant="accordion"
                                    outlined
                                    :value="openedChartExpansionPanel"
                                >
                                    <v-expansion-panel
                                        v-for="theme of chartsThemeSettings.themesList"
                                        :key="theme.id"
                                    >
                                        <v-expansion-panel-title
                                            class="px-2 d-flex flex-row align-center"
                                            disable-icon-rotate
                                        >
                                            <span
                                                ><strong>{{ theme.displayName }}</strong></span
                                            >
                                            <template v-slot:actions>
                                                <v-btn-icon
                                                    icon="$oss-edit"
                                                    size="small"
                                                    density="compact"
                                                />
                                                <v-btn-icon
                                                    v-if="theme.id !== 'default'"
                                                    icon="$oss-trash"
                                                    size="small"
                                                    density="compact"
                                                    class="ml-2"
                                                    @click.stop="deleteChartTheme(theme.id)"
                                                >
                                                    <v-icon color="error" />
                                                </v-btn-icon>
                                            </template>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="wrapper-px-2">
                                            <div v-if="theme.id !== 'default'" class="px-1 pb-3">
                                                <v-text-field-filled
                                                    v-model="theme.displayName"
                                                    label="Nom de la configuration"
                                                    outlined
                                                    hide-details
                                                    class
                                                    density="compact"
                                                >
                                                </v-text-field-filled>
                                            </div>
                                            <PropertiesEditor
                                                v-if="chartsThemeSettingsOptions.properties"
                                                :perRow="2"
                                                :properties="theme.values"
                                                :propertiesOptions="
                                                    chartsThemeSettingsOptions.properties
                                                "
                                            />
                                            <v-divider class="my-3" />
                                            <span>{{
                                                chartsThemeSettingsOptions.title.label
                                            }}</span>
                                            <PropertiesEditor
                                                v-if="chartsThemeSettingsOptions.title.properties"
                                                :perRow="2"
                                                :properties="theme.values.title"
                                                :propertiesOptions="
                                                    chartsThemeSettingsOptions.title.properties
                                                "
                                            />
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                    <v-expansion-panel class="d-flex flex-row justify-end">
                                        <v-btn
                                            dark
                                            color="primary"
                                            elevation="0"
                                            rounded
                                            dense
                                            @click="addChartTheme"
                                            size="small"
                                        >
                                            <v-icon class="mr-2" size="small">$fa-plus</v-icon>
                                            Nouvelle configuration
                                        </v-btn>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-title class="d-flex flex-row justify-between px-2">
                                <div>
                                    <v-icon class="mr-2" size="small">$fa-th-list</v-icon>
                                    {{ tablesThemeSettingsOptions.label }}
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="wrapper-px-2">
                                <v-expansion-panels
                                    flat
                                    variant="accordion"
                                    outlined
                                    :value="openedTablesExpansionPanel"
                                >
                                    <v-expansion-panel
                                        v-for="theme of tablesThemeSettings.themesList"
                                        :key="theme.id"
                                    >
                                        <v-expansion-panel-title
                                            class="px-2 d-flex flex-row align-center"
                                            disable-icon-rotate
                                        >
                                            <span>
                                                <strong>{{ theme.displayName }}</strong>
                                            </span>
                                            <template v-slot:actions>
                                                <v-btn-icon
                                                    icon="$oss-edit"
                                                    size="small"
                                                    density="compact"
                                                />
                                                <v-btn-icon
                                                    v-if="theme.id !== 'default'"
                                                    icon="$oss-trash"
                                                    size="small"
                                                    density="compact"
                                                    class="ml-2"
                                                    @click.stop="deleteTableTheme(theme.id)"
                                                >
                                                    <v-icon color="error" />
                                                </v-btn-icon>
                                            </template>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="wrapper-px-2">
                                            <div v-if="theme.id !== 'default'" class="px-1 pb-3">
                                                <v-text-field-filled
                                                    v-model="theme.displayName"
                                                    label="Nom de la configuration"
                                                    outlined
                                                    hide-details
                                                    class
                                                    density="compact"
                                                >
                                                </v-text-field-filled>
                                            </div>
                                            <PropertiesEditor
                                                v-if="tablesThemeSettingsOptions.properties"
                                                :perRow="2"
                                                :properties="theme.values"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.properties
                                                "
                                            />
                                            <v-divider class="my-3" />

                                            <span>{{
                                                tablesThemeSettingsOptions.header.label
                                            }}</span>
                                            <PropertiesEditor
                                                v-if="tablesThemeSettingsOptions.header.properties"
                                                :perRow="2"
                                                :properties="theme.values.header"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.header.properties
                                                "
                                            />
                                            <v-divider class="my-3" />

                                            <span>{{ tablesThemeSettingsOptions.rows.label }}</span>
                                            <PropertiesEditor
                                                v-if="tablesThemeSettingsOptions.rows.properties"
                                                :perRow="2"
                                                :properties="theme.values.rows"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.rows.properties
                                                "
                                            />
                                            <v-divider class="my-3" />

                                            <span>{{
                                                tablesThemeSettingsOptions.title.label
                                            }}</span>
                                            <PropertiesEditor
                                                v-if="tablesThemeSettingsOptions.title.properties"
                                                :perRow="2"
                                                :properties="theme.values.title"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.title.properties
                                                "
                                            />
                                            <v-divider class="my-3" />

                                            <span>{{
                                                tablesThemeSettingsOptions.subtotals.label
                                            }}</span>
                                            <PropertiesEditor
                                                v-if="
                                                    tablesThemeSettingsOptions.subtotals.properties
                                                "
                                                :perRow="2"
                                                :properties="theme.values.subtotals"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.subtotals.properties
                                                "
                                            />
                                            <v-divider class="my-3" />

                                            <span>{{
                                                tablesThemeSettingsOptions.totals.label
                                            }}</span>
                                            <PropertiesEditor
                                                v-if="tablesThemeSettingsOptions.totals.properties"
                                                :perRow="2"
                                                :properties="theme.values.totals"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.totals.properties
                                                "
                                            />
                                            <v-divider class="my-3" />

                                            <span>{{
                                                tablesThemeSettingsOptions.footer.label
                                            }}</span>
                                            <PropertiesEditor
                                                v-if="tablesThemeSettingsOptions.footer.properties"
                                                :perRow="2"
                                                :properties="theme.values.footer"
                                                :propertiesOptions="
                                                    tablesThemeSettingsOptions.footer.properties
                                                "
                                            />
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                    <v-expansion-panel class="d-flex flex-row justify-end">
                                        <v-btn
                                            dark
                                            color="primary"
                                            elevation="0"
                                            rounded
                                            dense
                                            @click="addTableTheme"
                                            size="small"
                                        >
                                            <v-icon class="mr-2" size="small">$fa-plus</v-icon>
                                            Nouvelle configuration
                                        </v-btn>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
            <!-- <v-row no-gutters class="px-2 py-3 scrollbar-hidden" style="max-height: calc(40vh - 54px - 22px); overflow-y: auto; position: relative; z-index: 2; box-shadow: 0px -3px 2px -1px rgba(0, 0, 0, 0.2)">
                
            </v-row> -->
        </v-card>
    </div>
</template>
<script lang="ts">
import PropertiesEditor from "./PropertiesEditor.vue";
import {
    generalThemeSettingsOptions,
    chartsThemeSettingsOptions,
    tablesThemeSettingsOptions,
} from "./themesOptions";
import _ from "lodash";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        PropertiesEditor,
    },
})
export class DesignerTheme extends Vue {
    @Prop({ default: null }) generalThemeSettings: any;
    @Prop({ default: null }) chartsThemeSettings: any;
    @Prop({ default: null }) tablesThemeSettings: any;

    titleLevels = ["h1", "h2", "h3"]; // Title levels in the designer. They should exist in the theme edit config json and in the properties values

    get generalThemeSettingsOptions() {
        return generalThemeSettingsOptions;
    }

    get chartsThemeSettingsOptions() {
        return chartsThemeSettingsOptions;
    }

    get tablesThemeSettingsOptions() {
        return tablesThemeSettingsOptions;
    }

    // themeSettings: any = {
    //     table: {
    //         header: {
    //             background: "",
    //             color: "",
    //             textAlign: "left",
    //             border: ""
    //         },
    //         rows: {
    //             background: "",
    //             color: "",
    //             textAlign: "left",
    //             border: ""
    //         },
    //         title: {
    //             bold: false
    //         }
    //     }
    // }

    /**
     * Get object by a list of chained keys.
     * eg: [a, b] should return "OK" with {a: {b: 'OK'}}
     * @param obj
     * @param keys
     */
    getObjectByKeysChain(obj: any, keys: string | string[]) {
        if (!Array.isArray(keys)) {
            return obj?.[keys];
        }
        let out = keys.length || keys.length === 0 ? obj : undefined;
        for (const key of keys) {
            out = out?.[key];
            if (out == null) break;
        }
        return out;
    }

    // getKeysAndOptions(themeSettings, themeSettingsOptions) {
    //     const out = []
    //     for (const key of Object.keys(themeSettings)) {
    //         const options = themeSettingsOptions?.[key]
    //         out.push({
    //             key,
    //             options
    //         })
    //     }

    //     console.log("out", out)
    //     return out
    // }

    openedChartExpansionPanel = null;
    openedTablesExpansionPanel = null;

    _generateId() {
        return "theme_" + Math.random().toString(36).substring(2, 17);
    }

    addChartTheme() {
        const defaultCopy = _.cloneDeep(this.chartsThemeSettings.themesList[0]);
        defaultCopy.id = this._generateId();
        defaultCopy.displayName = "Nouvelle configuration";
        this.chartsThemeSettings.themesList.push(defaultCopy);
        this.openedChartExpansionPanel = this.chartsThemeSettings.themesList.length;
    }

    addTableTheme() {
        const defaultCopy = _.cloneDeep(this.tablesThemeSettings.themesList[0]);
        defaultCopy.id = this._generateId();
        defaultCopy.displayName = "Nouvelle configuration";
        this.tablesThemeSettings.themesList.push(defaultCopy);
        this.openedTablesExpansionPanel = this.tablesThemeSettings.themesList.length;
    }

    deleteChartTheme(themeId) {
        if (themeId !== "default") {
            const previouslyOpen = this.openedChartExpansionPanel ?? 0;
            this.chartsThemeSettings.themesList = this.chartsThemeSettings.themesList.filter(
                (theme) => theme.id !== themeId
            );
            this.openedChartExpansionPanel = previouslyOpen - 1;
        }
    }

    deleteTableTheme(themeId) {
        if (themeId !== "default") {
            const previouslyOpen = this.openedTablesExpansionPanel ?? 0;
            this.tablesThemeSettings.themesList = this.tablesThemeSettings.themesList.filter(
                (theme) => theme.id !== themeId
            );
            this.openedTablesExpansionPanel = previouslyOpen - 1;
        }
    }

    textStyle(styleObject) {
        if (!styleObject) return styleObject;
        const objCopy = { ...styleObject };
        if (objCopy.italic === true) {
            objCopy.fontStyle = "italic";
        }
        objCopy.fontSize = objCopy.fontSize + "pt";
        objCopy.fontWeight = objCopy.bold ? "bold" : null;
        return objCopy;
    }
}

export default toNative(DesignerTheme);
</script>
<style lang="css" scoped>
:deep(:is(input, .v-label, .v-select__selection)) {
    font-size: 0.8em;
}

.wrapper-px-2 > :deep(.v-expansion-panel-text__wrapper) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}
</style>
